/* eslint-env jest */
import { parseTimezone } from '../time'

describe('parseTimezone', () => {
  test('converts UTC instant to clock time in the event timezone (Vancouver, PDT)', () => {
    const parsed = parseTimezone('2026-07-01T17:00:00Z', 'America/Vancouver')

    expect(parsed.format('YYYY-MM-DD')).toBe('2026-07-01')
    expect(parsed.format('HH:mm')).toBe('10:00')
  })

  test('uses the given event timezone, not another region', () => {
    const iso = '2026-07-01T10:00:00-07:00'

    expect(parseTimezone(iso, 'America/Vancouver').format('HH:mm')).toBe('10:00')
    expect(parseTimezone(iso, 'America/Toronto').format('HH:mm')).toBe('13:00')
  })
})
